<template>
  <z-dialogo
    ref="dialogo"
    largura="1280px"
    altura="500px"
    titulo="Histórico Produto"
    no-padding
    scrollable
    dividers
  >
    <template v-slot:prepend>

      <v-card flat>
        <v-card-title>
          <div>
            {{ produto.referencia }} {{ produto.lote_id ? `(${produto.lote_id})` : '' }} - {{ produto.descricao }}
          </div>
          <v-spacer></v-spacer>
          <div>
            Estoque: {{ produto.estoque }}
          </div>
        </v-card-title>

        <!-- <v-card-subtitle>
          Estoque atual: {{ produto.estoque }}
        </v-card-subtitle> -->
      </v-card>

      <v-divider></v-divider>
      <v-tabs color="primary" v-model="tab">
        <v-tabs-slider color="primary" v-model="tab"></v-tabs-slider>
        <v-tab>Histórico</v-tab>
        <!-- <v-tab>Resumo</v-tab> -->
        <v-tab>Entradas</v-tab>
        <v-tab>Gráfico de Vendas Mensal</v-tab>

        <v-slide-x-transition>
          <div v-if="tab == 0" class="d-flex align-center justify-end flex-grow-1 pr-5">
            <span class="mr-3 text--primary">A partir de:</span>
            <z-date-navigation
              color="grey lighten-2"
              v-model="data"
              sem-setas
              @input="dataChange"
            ></z-date-navigation>
          </div>
        </v-slide-x-transition>
      </v-tabs>
    </template>

    <template v-slot:conteudo>
      <z-loading v-if="loading" :loading="loading" class="mx-3"></z-loading>

      <v-tabs-items v-model="tab" v-else>
        <v-tab-item>
          <historico-lista :historico="historico"></historico-lista>
          <div id="final"></div>
        </v-tab-item>

        <v-tab-item>
          <historico-entradas :entradas="entradas"></historico-entradas>
        </v-tab-item>

        <v-tab-item>
          <div class="d-flex justify-center pt-4" style="width: 100%;">
            <bar-chart :dados="dados_grafico"></bar-chart>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </template>

    <template v-slot:actions_right>
      <v-btn id="btn-refresh" icon @click="dataChange" :loading="loading">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <v-btn depressed color="primary" @click="fechar">Fechar</v-btn>
    </template>
  </z-dialogo>
</template>

<script>
import BarChart from "@/components/graficos/BarChart";
// import HistoricoResumo from "./HistoricoResumo";
import HistoricoLista from "./HistoricoLista";
import HistoricoEntradas from "./HistoricoEntradas";

export default {
  name: "HistoricoProduto",

  components: {
    BarChart,
    // HistoricoResumo,
    HistoricoLista,
    HistoricoEntradas
  },

  data() {
    return {
      tab: 0,
      loading: false,
      value: [423, 446, 675, 510, 590, 610, 760],
      dados_grafico: {},
      resumo: {
        ultima_os: 1234,
        data_ultima_os: "16/03/2021",
        ultima_venda: 14123,
        data_ultima_venda: "16/03/2021",
        ultima_entrada: 14123,
        data_ultima_entrada: "16/03/2021",
      },
      historico: [],
      entradas: [],
      produto: {},
      data: new Date().toISOString().substring(0, 10),
    };
  },

  computed: {
    produto_selecionado() {
      return this.$store.state.produtos.produto; 
    }
  },

  methods: {
    async abrir() {
      this.tab = 0;
      // console.log(this.codigo);
      // await this.getDadosGrafico(this.codigo);
      this.setData();
      await this.getAllData(this.produto_selecionado.id);
      this.$refs.dialogo.abrir();
    },

    fechar() {
      this.$refs.dialogo.fechar();
      this.tab = 0;
    },

    setData() {
      let data = new Date();
      data.setDate(data.getDate() - 7);
      this.data = data.toISOString().substring(0, 10);
    },

    dataChange() {
      this.getAllData(this.produto_selecionado.id);
    },

    onScroll(e) {
      this.offsetTop = window.pageYOffset;
    },

    async getAllData(codigo) {
      try {
        this.loading = true;
        await this.getDadosGrafico(codigo);
        await this.getHistorico(codigo);
        // await this.getResumo(codigo);

        setTimeout(() => {
          const final_el = document.getElementById("final");
  
          if (final_el) {
            final_el.scrollIntoView({ behavior: "smooth" });
            // this.$vuetify.goTo("#final", { duration: 300, offset: 30 });
          }
        }, 500);
      } catch (error) {
        throw error;
      } finally {
        this.loading = false;
      }
    },

    async getDadosGrafico(codigo) {
      this.dados_grafico = await this.$axios
        .get(`produtos/${codigo}/historico/grafico`)
        .then((response) => response.data);
    },

    async getHistorico(codigo) {
      const response = await this.$axios
        .get(`produtos/${codigo}/historico?data=${this.data}`)
        .then((response) => response.data);

      this.historico = response.historico;
      this.entradas = response.entradas;
      this.produto = response.produto;
    },

    async getResumo(codigo) {
      this.resumo = await this.$axios
        .get(`produtos/historico/resumo?codigo=${codigo}`)
        .then((response) => response.data);
    },
  },

  // watch: {
  //   async codigo(newValue, oldValue) {
  //     try {
  //       this.loading = true;
  //       await this.getDadosGrafico(newValue);
  //       // await this.getHistorico(newValue);
  //       await this.getResumo(newValue);
  //     } catch (error) {
  //       throw error;
  //     } finally {
  //       this.loading = false;
  //     }
  //   },
  // },
};
</script>

<style lang="scss" scoped></style>
